import { AuthProvider } from "./context/AuthContext";
import { Routing } from "./Routing";

export const AuthWrapper = () => {
  return (
    <AuthProvider>
      <Routing />
    </AuthProvider>
  );
};
